export default {
	transitionWords: 400,
	keyphraseDensity: 200,
};
